/*
 * BBC - Rap Map - Social Media share links
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareAlt, faLink } from '@fortawesome/free-solid-svg-icons';
import NativeShare from '../utilities/NativeShare';
import CloseIcon from './assets/CloseIcon.svg';

const ShareLinks = () => {
    const shareButton = useRef(0);
    const copyText = useRef(0);
    const copyLink = useRef(0);
    const copyLinkContainer = useRef(0);
    const copyLinkClose = useRef(0);
    const shareURL = window.location.href;

    useEffect(() => {
        NativeShare(
            shareButton.current, 
            copyText.current, 
            copyLink.current, 
            copyLinkContainer.current, 
            copyLinkClose.current
        );
    }, []);

    return (
        <div className="Sharers">
            <button id="share" className="Sharers__share" ref={shareButton}>
                <FontAwesomeIcon icon={faShareAlt} />
                <span>Share</span>
            </button>

            <div className="Sharers__copyLink" ref={copyLinkContainer}>
                <button id="copyLinkClose" ref={copyLinkClose} className="CloseButton">
                    <img src={CloseIcon} alt="" />
                </button>
                <button id="copyLink" ref={copyLink} className="Sharers__copyLink--button">
                    <FontAwesomeIcon icon={faLink} />
                    <span>Share link</span>
                </button>
                <a
                    href="https://www.bbc.co.uk/usingthebbc/terms/can-i-share-things-from-the-bbc"
                    target="_blank"
                    rel="noreferrer noopener"
                >
                    About sharing
                </a>
            </div>

            <input
                id="copyText"
                ref={copyText}
                className="vh"
                readOnly
                value={shareURL}
                aria-label="hidden"
                type="text"
            ></input>
        </div>
    );
};

export default ShareLinks;
